module.exports = "mutation DeleteProductInsertRelation($id:ID!){deleteProductInsertRelation(relationId:$id){success}}"